import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import UserService from '../../services/UserService';
import CompanyMasterService from '../../services/CompanyMasterService';
import WareHouseMaterService from '../../services/WareHouseMaterService';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $ from 'jquery';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';

export default class UserMaster extends Component {
    constructor(props) {
        super(props);
        this.ApiService = new ApiService();
        this.UserService = new UserService();
        this.CompanyMasterService = new CompanyMasterService();
        this.WareHouseMaterService = new WareHouseMaterService();

        this.tblResponse = new tableRequest();
        this.state = {
            mobileuserdisplay: false,
            compDisabled: false,
            visible: false,
            ReferenceID: '',
            updateLoader: false,
            sortIcon: false,
            IsAdmin: false, // default value (false for "Web User")
            isAdminSelected: false,
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            WID: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: false,
            StokcIn: false,
            sortOrder: '',
            CompanyId: '',
            WareHouseId: '',
            IsFactory: '',
            IsDepot: '',
            formError: {
                UserName: '',
                FirstName: '',
                LastName: '',
                Password: '',
                Email: '',
                ConfirmPassword: '',
                MobileNo: '',
                CompanyId: '',
                WareHouseId: ''

            },

            formHeading: 'Add User',
            buttonLabel: 'Submit',
            sales: [],
            companyDDL: [],
            wareHouseDDL: [],
            wareHouseFactoryDDL: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            UserType: 0
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.emailTemplate = this.emailTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetUsers();
            this.GetCompany();
            this.GetWareHouse(0);
        }, 1000);

        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }
    //on page loading
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetUsers();
        }, 250);
    }

    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.UserType = 0;
    }

    // get users data list from api
    GetUsers() {
        this.tblResponse.SortColumn = 'CreatedDt';
        this.UserService.GetUsers(this.tblResponse).then(data => {
            debugger
            const resdata = data.data;
            //if response data is not null sales state will be set with ResponseData
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false,
                    updateLoader: true
                });
            }
            //if response data is null sales state will be set null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false,
                    updateLoader: true

                });
            }
        });
    }

    handleChange2 = (e) => {
      
        console.log("Selected Items:", e.value); 
        if (Array.isArray(e.value)) {
          
            const selectedIds = e.value.map(item => item.ID); 
            console.log("Selected IDs:", selectedIds); 

           
            this.setState(prevState => {
                const updatedWareHouseIds = [
                    ...prevState.WareHouseId,  
                    ...selectedIds.filter(id => !prevState.WareHouseId.includes(id)) 
                ];

                return {
                    WareHouseId: updatedWareHouseIds 
                };
                // const commaSeparatedIds = updatedWareHouseIds.join(', ');
           // this.setState({ WarehouseIdAdmin: commaSeparatedIds });
               
            });
            
        }
    };
    

    
    handleChange(event) {
        debugger
        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
        if (name === "IsAdmin") {
            this.setState({ isAdminSelected: value ,StockIn:false});
        }
        if (name === "WarehouseId") {
            this.setState({ WarehouseId: value.ID });
        }

        if (name == "IsActive")
            this.setState({
                IsActive: event.target.checked
            });

            if (name == "StockIn")
                this.setState({
                    StockIn: event.target.checked
                });    

    }

    //to validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        //to validate each form field with required conditions
        switch (name) {
            case 'UserName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UserName = "Please enter your username.";
                } else errors.UserName = ''
                break;
            case 'FirstName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.FirstName = "Please enter your first name.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[A-Za-z]+$/)) {
                        IsValid = false;
                        errors.FirstName = "FirstName should be alpha only."
                    } else errors.FirstName = ''
                }
                else errors.FirstName = ''
                break;
            case 'LastName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.LastName = "Please enter your last name.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[A-Za-z]+$/)) {
                        IsValid = false;
                        errors.LastName = "LastName should be alpha only."
                    } else errors.LastName = ''
                }
                else errors.LastName = ''
                break;
            case 'Email':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Email = "Please enter your email-id.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                        IsValid = false;
                        errors.Email = "Please enter valid email-id.";
                    } else errors.Email = ''
                } else errors.Email = ''
                break;
            case 'MobileNo':
                if (value.length < 1) {
                    IsValid = false;
                    errors.MobileNo = "Please enter your mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[6-9]\d{9}$/)) {
                        IsValid = false;
                        errors.MobileNo = "Please enter valid mobile no.";
                    } else errors.MobileNo = ''
                } else errors.MobileNo = ''
                break;
            case 'Password':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Password = "Please enter password.";
                }
                //^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,10}$
                else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,10}$/)) {
                    IsValid = false;
                    errors.Password = "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
                }


                else if (value.length >= 1 && this.state.ConfirmPassword.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.ConfirmPassword)) {
                        IsValid = false;
                        errors.Password = "password does not match";
                    } else errors.Password = ''
                } else errors.Password = ''
                break;

            case 'ConfirmPassword':
                if (value.length < 1) {
                    IsValid = false;
                    errors.ConfirmPassword = "Please enter confirm password.";
                }
                else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,10}$/)) {
                    IsValid = false;
                    errors.ConfirmPassword = "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
                }
                else if (value.length >= 1 && this.state.Password.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.Password)) {
                        IsValid = false;
                        errors.ConfirmPassword = "Confirm password does not match";
                    } else errors.ConfirmPassword = ''
                } else errors.ConfirmPassword = ''
                break;

            case 'CompanyId':
                debugger
                if (value == undefined || value == '') {
                    IsValid = false;
                    errors.CompanyId = "Please select Company";
                }
                else {
                    errors.CompanyId = '';
                    this.GetWareHouse(value.CompId)
                }
                break;
            case 'WareHouseId':
                if (value == undefined || value == '') {
                    IsValid = false;
                    errors.WareHouseId = "Please select WareHouse / Factory";
                } else {
                    errors.WareHouseId = '';
                }
                break;
            default:
                break;
        }

        return IsValid;
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true,
            StockIn:false,
            //CompanyId :'',
            WareHouseId: '',

        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }

    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add User'
        })
        this.formReset();
    }
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }
    // submit form and create or update user
    submitForm(event) {
        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //form is not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });
        //form is valid
         if (isfrmvalid) {
            let WID = ''; 
            debugger;
            if ( this.state.WareHouseId.length >1)
                {
                    WID = this.state.WareHouseId.join(', ');
                }
                else
                {
                    WID = this.state.WareHouseId.ID;
                }
                let WareHouseId = WID;
            this.setState({ updateLoader: false })
            const formData = {
                UserName: this.state.UserName,
                FirstName: this.state.FirstName,
                LastName: this.state.LastName,
                Email: this.state.Email,
                MobileNo: this.state.MobileNo,
                WarehouseId:WareHouseId,
                Password: this.state.Password,
                ReferenceID: this.state.ReferenceID,
                IsActive: this.state.IsActive,
                CompanyId: this.state.CompanyId.CompId,
               // WareHouseId:WareHouseId,
               
               
                UserType: this.state.UserType,
                IsAdmin: this.state.IsAdmin,
                StockIn: this.state.StockIn

            }

            setTimeout(() => {
                this.UserService.CreateUpdateUser(formData).then(data => {
                    const resdata = data.data;
                    //if responsecode is 200 success message willl be shown else it will move to 'else statement'
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });
                        this.formReset();
                        this.GetUsers();
                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });
                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });
                    }
                });
            }, 1000);
        }
    }

    // delete user data
    deleteUser(referenceID) {
        this.UserService.DeleteUser(referenceID).then(data => {
            const resdata = data.data;
            //if responsecode is 200 success message willl be shown else it will move to 'else statement'
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                this.GetUsers();
                const totlrecord = this.state.totalRecords - 1;
                const row = this.state.rows;

                if (this.tblResponse.First >= totlrecord) {
                    const _curntCursor = Math.round(totlrecord / row);
                    this.tblResponse.First = _curntCursor + 1;
                }

            } else if (resdata.ResponseCode === '400') {
                this.refs.Messchild.showWarn(resdata.ResponseMessage);
            } else {
                this.refs.Messchild.showError(resdata.ResponseMessage);
            }
        });
    }
    //to get  company data for ddl
    GetCompany() {
        this.CompanyMasterService.GetCompanyDDL().then(data => {
            const resdata = data.data;
            //if resdata is not null state of companyDDL will be set with ResponseData
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.setState({
                    companyDDL: resdata.ResponseData,
                    compDisabled: true
                });
            }

            if (this.ApiService.getIsAdmin() == "true")
                debugger
            {

                const CompanyObj = this.state.companyDDL.filter(x => x.CompId == this.ApiService.getCompanyId());
                this.setState({
                    CompanyId: CompanyObj[0],
                    compDisabled: true
                });
                //this.GetWareHouse(this.state.CompanyId.CompId)

            }


        });
    }


    GetAllWarehouse() {
        this.CompanyMasterService.GetCompanyDDL().then(data => {
            const resdata = data.data;
            //if resdata is not null state of companyDDL will be set with ResponseData
           // if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                // this.setState({
                //     companyDDL: resdata.ResponseData,
                //     compDisabled: true
                // });
            //}

           


        });
    }
    //to get warehouse data for ddl
    GetWareHouse(compId) {
        this.WareHouseMaterService.GetWareHouseDDL(compId).then(data => {
            const resdata = data.data;
            //if resdata is not null state of wareHouseDDL will be set with ResponseData
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({
                    wareHouseFactoryDDL: resdata.ResponseData,
                    wareHouseDDL: []
                });
            }
        });
    }
    GetDepot(compId) {
        this.UserService.GetDepot(compId).then(data => {
            const resdata = data.data;
            //if resdata is not null state of wareHouseDDL will be set with ResponseData
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({
                    depotDDL: resdata.ResponseData,
                    depotUserDDL: []
                });
            }
        });
    }
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetUsers();
    }


    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    onValueChange(event) {
        debugger

        const val = event.target.value;

        if (val == "0") {
            const wareHouse = this.state.wareHouseFactoryDDL.filter((x) => x.IsFactory == 0 && x.IsDepot == 0);
            this.setState({
                IsFactory: false,
                IsDepot: false,
                wareHouseDDL: wareHouse,
                WareHouseId: '',
                UserType: 5
                // warehouseVisible: true,
            });
        }
        if (val == "1") {


            const Factory = this.state.wareHouseFactoryDDL.filter((x) => x.IsFactory == 1);

            this.setState({
                IsFactory: true,
                WareHouseId: '',
                wareHouseDDL: Factory,
                UserType: 4
                //  warehouseVisible: true,
            });


        }
        if (val == "2") {


            const Depot = this.state.wareHouseFactoryDDL.filter((x) => x.IsDepot == 1 && x.IsFactory == 0);

            this.setState({
                IsDepot: true,
                IsFactory: false,
                WareHouseId: '',
                wareHouseDDL: Depot,
                UserType: 7
                //  warehouseVisible: true,
            });


        }

    }

    // disabled checkbox
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }

    // sort data
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
        this.GetUsers();
        const clickData = document.getElementsByClassName("p-sortable-column-icon pi pi-fw pi-sort");
        console.log(event);
    }
    emailTemplate = (rowData) => {
        debugger;
        let emails = rowData.Email;
        return (
            <div className="scroll-content">
                <span className="p-column-title">Email</span>
                {emails}
            </div>
        )
    }
    // edit form 
    actionTemplate(rowData, column) {
        if (rowData.UserType === 3) {
            this.state.mobileuserdisplay = true
        }
        else {
            this.state.mobileuserdisplay = false
        }
        const editMode = (e) => {
            debugger
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update User',
                visible: true, ReferenceID: rowData.ReferenceID,
                UserName: rowData.Username,
                FirstName: rowData.FirstName,
                LastName: rowData.LastName,
                Email: rowData.Email,
                MobileNo: rowData.MobileNo,
                Password: rowData.Password,
                ConfirmPassword: rowData.Password,
                IsActive: rowData.IsActive,
                StockIn: rowData.StockIn,
                UserType: rowData.UserType
            });
            this.setState({
               IsAdmin :rowData.IsAdmin,
               isAdminSelected: rowData.IsAdmin
            });
            const CompanyObj = this.state.companyDDL.filter(x => x.CompId == rowData.CompanyId);
            const wareHouse = this.state.wareHouseFactoryDDL.filter((x) => x.IsFactory == 0 && x.IsDepot == 0);
            const Factory = this.state.wareHouseFactoryDDL.filter((x) => x.IsFactory == 1);
            const wareHouseObj = this.state.wareHouseFactoryDDL.filter(x => x.ID == rowData.WareHouseId)
            const Depot = this.state.wareHouseFactoryDDL.filter((x) => x.IsDepot == 1 && x.IsFactory == 0);
            debugger

            if (wareHouseObj[0].IsFactory) {
                this.setState({
                    IsFactory: true,
                    IsDepot: false,
                    wareHouseDDL: Factory,
                });
            } else if (wareHouseObj[0].IsDepot) {
                this.setState({
                    IsFactory: false,
                    IsDepot: true,
                    wareHouseDDL: Depot,
                });
            } else {
                this.setState({
                    IsFactory: false,
                    IsDepot: false,
                    wareHouseDDL: wareHouse,
                });
            }

            this.setState({
                CompanyId: CompanyObj[0],
                WareHouseId: wareHouseObj[0],

            });
        }

        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteUser(rowData.ReferenceID)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>
            <Button type="button" disabled={this.state.mobileuserdisplay} icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }

    // create html part
    //resolved KREP-85
    render() {
        let header = (
            <div style={{ 'textAlign': 'right' }}>
                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
            </div>
        );

        return (
            <>
                <MessageComponent ref="Messchild" />
                <Loaders loader={this.state.updateLoader} />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <h1>User Master</h1>
                    <Button label="Add User" icon="pi pi-plus-circle" onClick={this.openDialog} />
                </div>

                <DataTable responsive={true}
                    header={header}
                    style={{ width: '100%' }}
                    scrollable globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage}
                    value={this.state.sales}
                    sortMode="multiple"
                    paginator={true}
                    rows={this.state.rows}
                    rowsPerPageOptions={[5, 10, 20]}
                    totalRecords={this.state.totalRecords}
                    lazy={true}
                    first={this.state.first}
                    onPage={this.onPage}
                    onSort={this.onSort}
                    className="tblAuto">

                    <Column field="Username" headerStyle={{ width: '180px' }} header="User Name" sortable={true} />
                    <Column field="FirmName" headerStyle={{ width: '200px' }} header="Factory / WareHouse" sortable={true} />
                    <Column field="CompanyName" headerStyle={{ width: '200px' }} header="Company" sortable={true} />
                    <Column field="FirstName" headerStyle={{ width: '160px' }} header="First Name" sortable={true} />
                    <Column field="LastName" headerStyle={{ width: '160px' }} header="Last Name" sortable={true} />
                    <Column body={this.emailTemplate} headerStyle={{ width: '350px' }} header="Email" sortable={true} />
                    <Column field="MobileNo" headerStyle={{ width: '150px' }} header="Mobile No." sortable={true} />
                    <Column field="CreatedDate" headerStyle={{ width: '150px' }} header="Created Date" sortable={true} />
                    <Column body={this.activeTemplate} headerStyle={{ width: '80px' }} header="Status" />
                    <Column body={this.actionTemplate} headerStyle={{ width: '100px' }} header="Action" />
                </DataTable>

                <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>

                    <form onSubmit={this.submitForm} className="form-padding" autoComplete="off">

                        <div className="row">
                            <div className="col-md-4 text-right">
                                <label>User Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" autoComplete="off" value={this.state.UserName} onChange={this.handleChange} className="form-control" name="UserName" />
                                {this.state.formError.UserName !== '' ?
                                    <div className='error'>{this.state.formError.UserName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>First Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.FirstName} onChange={this.handleChange} className="form-control" name="FirstName" />
                                {this.state.formError.FirstName !== '' ?
                                    <div className='error'>{this.state.formError.FirstName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Last Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.LastName} onChange={this.handleChange} className="form-control" name="LastName" />
                                {this.state.formError.LastName !== '' ?
                                    <div className='error'>{this.state.formError.LastName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Email<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" autoComplete="off" value={this.state.Email} onChange={this.handleChange} className="form-control" name="Email" />
                                {this.state.formError.Email !== null ?
                                    <div className='error'>{this.state.formError.Email}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Mobile Number<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" autoComplete="off" maxLength={10} value={this.state.MobileNo} onChange={this.handleChange} className="form-control" name="MobileNo" />
                                {this.state.formError.MobileNo !== null ?
                                    <div className='error'>{this.state.formError.MobileNo}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Password<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="password" autoComplete="new-password" value={this.state.Password} onChange={this.handleChange} className="form-control" name="Password" noValidate />
                                {this.state.formError.Password !== null ?
                                    <div className='error'>{this.state.formError.Password}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Confirm Password<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="password" autoComplete="off" value={this.state.ConfirmPassword} onChange={this.handleChange} className="form-control" name="ConfirmPassword" />
                                {this.state.formError.ConfirmPassword !== null ?
                                    <div className='error'>{this.state.formError.ConfirmPassword}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
    <label>User Type<span>*</span>:</label>
</div>
<div className="col-md-8 mb-2">
    <Dropdown
        optionLabel="label"
        value={this.state.IsAdmin}  // Ensure this is correctly tied to the state
        onChange={e => this.handleChange(e)}  // Handle any changes made to the dropdown
        className="form-control"
        name="IsAdmin"
        options={[
            { label: 'Web User', value: false },  // false = Web User
            { label: 'Admin User', value: true }   // true = Admin User
        ]}
    />
    {this.state.formError.UserType !== null ? <div className='error'>{this.state.formError.UserType}</div> : null}
</div>
                            <div className="col-md-4 text-right">
                                <label>Company<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">

                                <Dropdown appendTo={document.getElementById('root')} disabled={this.state.compDisabled} optionLabel="CompanyName" onChange={e => { this.handleChange(e) }} value={this.state.CompanyId} className="form-control" placeholder="Select Company" name="CompanyId" options={this.state.companyDDL} />
                                {this.state.formError.CompanyId !== null ?
                                    <div className='error'>{this.state.formError.CompanyId}</div> : null}
                            </div>



                            {/* <div className="col-md-4 text-right">
                                <label>WareHouse<span>*</span>:</label>
                            </div> */}

                            <div className="col-md-4">
                                <input

                                    checked={this.state.IsFactory === true}
                                    type="radio"
                                    value="1"
                                    name="ddlType"
                                    onChange={this.onValueChange}
                                />{" "}
                                Factory

                                <input
                                    checked={this.state.IsDepot === true && this.state.IsFactory === false}
                                    type="radio"
                                    value="2"
                                    name="ddlType"
                                    className='ml-4'
                                    onChange={this.onValueChange}
                                />
                                {" "}
                                Depot

                            </div>

                            <div className="col-md-6 mb-2">
                                {/* {this.state.isAdminSelected ? (
                                    <MultiSelect
                                    appendTo={document.getElementById('root')}
                                    multiple
                                    optionLabel="FirmName"
                                    onChange={this.handleChange2}
                                    value={this.state.wareHouseDDL.filter(item => this.state.WareHouseId.includes(item.ID))}
                                    className="form-control"
                                    placeholder="-Select-"
                                    name="WareHouseId"
                                    style={{ 'width': '100%' }}
                                    options={this.state.wareHouseDDL}
                                /> 
                                ) : ( */}
                                    <Dropdown
                                        appendTo={document.getElementById('root')}
                                        optionLabel="FirmName"
                                        onChange={this.handleChange}
                                        value={this.state.WareHouseId}
                                        className="form-control"
                                        placeholder="-Select-"
                                        name="WareHouseId"
                                        options={this.state.wareHouseDDL}
                                    />
                                {/* )} */}
                                {this.state.formError.WareHouseId !== null ? <div className='error'>{this.state.formError.WareHouseId}</div> : null}
                            </div>
                          
                            <div className="col-md-4 text-right">
                                <label>IsActive :</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="checkbox" checked={this.state.IsActive} className="ml-2" name="IsActive" onChange={this.handleChange} />
                            </div>
                            {!this.state.isAdminSelected && (
        <>
            <div className="col-md-4 text-right">
                <label>Stock-In:</label>
            </div>
            <div className="col-md-8 mb-2">
                <input
                    type="checkbox"
                    checked={this.state.StockIn}
                    className="ml-2"
                    name="StockIn"
                    onChange={this.handleChange}
                        
                />
            </div>
        </>
        
        
    )}
                            <div className="col-md-12 text-center">
                                <button type="submit" className="btn btn-primary">{this.state.buttonLabel}</button>
                            </div>
                            <div className="col-md-12 text-left">
                                <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                            </div>
                        </div>
                    </form>
                </Dialog>
            </>
        )
    }
}